<template lang="pug">
  thead
    tr
      th #
      th Fecha#[br]Venc.
      th Saldo#[br]Inicial
      th Principal
      th Interés
      th Seguro#[br]Inmueble.
      th Mora y#[br]Penali.
      th Cuota
      th Total#[br]Abonado
      th Total#[br]Amortizado
      th Saldo final
      th Fecha#[br]Pago
      th Estado
</template>

<script>
export default {
  name: 'borrower-statement-table-head',
};
</script>

<style lang="sass" scoped>

</style>
